import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

// Define what the field returns (object containing the repository entityRef string and infrastructure dependencies)
export const RepositoryOnboardingFieldSchema = makeFieldSchemaFromZod(
  z
    .object({
      value: z
        .string()
        .describe(
          'Selected repository entityRef (stringifyEntityRef output, e.g., "component:default/my-repo")',
        ),
      infrastructureDependencies: z
        .array(z.string())
        .optional()
        .describe(
          'Selected infrastructure dependencies as array of entity reference strings (e.g., ["infrastructure:default/eks-cluster-1"])',
        ),
      providesApis: z
        .array(z.string())
        .optional()
        .describe(
          'Selected APIs that this component provides as array of entity reference strings (e.g., ["api:default/user-api"])',
        ),
    })
    .describe('Repository onboarding field data'),
);

export type RepositoryOnboardingFieldProps =
  typeof RepositoryOnboardingFieldSchema.type;

// Define UI options for the field
export interface RepositoryOnboardingUiOptions {
  'ui:placeholder'?: string;
  'ui:help'?: string;
  'ui:description'?: string;
}

// Export the schema for registration
export const RepositoryOnboardingSchema =
  RepositoryOnboardingFieldSchema.schema;
